import { FeatureConfig } from "@/types";
import { RouteRecordRaw } from "vue-router";

// 목록(메인), 새로 만들기 폼, 업데이트 폼 3개의 라우트를 만들어준다
export const makeDefaultRouteSet = (config: FeatureConfig): RouteRecordRaw[] => {
  // 기본, 헤더, 메뉴로 페이지가 구성
  // 기본 컴포넌트는 지정되고 각 기능별로 오버라이드가 가능
  const defaultComponents = {
    default: config.components?.default || (() => import("@/pages/Dashboard.vue")), // 기본 컴포넌트 제공
    header: config.components?.header ?? (() => import("@/components/layout/Header.vue")),
    menu: config.components?.menu ?? (() => import("@/components/layout/LeftMenu.vue")),
  };

  // 컴포넌트가 사용할 이름 설정
  const defaultName = config.name;

  const mainPageName = `${defaultName}Main`;

  // 기본 Props,
  // 자식 컴포넌트마다 다른 Props 설정 가능
  // 펑션 형태로 설정해서 실행 시간에 값 변경 가능하도록
  const defaultProps = {
    default: (route: { params: any }) => ({
      ...route.params,
      showColumns: config.columns,
      subColumns: config.subColumns,
      repository: config.repositories?.default,
      subRepository: config.repositories?.sub,
      repositories: config.repositories,
    }),
    menu: (route: { params: any }) => ({
      ...route.params,
    }),
    header: (route: { params: any }) => ({
      ...route.params,
      pageTitle: config.title,
    }),
  };

  return [
    {
      name: mainPageName,
      path: config.path,
      components: defaultComponents,
      meta: {
        currentMenu: config.currentMenu,
        menuNm: config.name,
        down: false,
        kind: config.kind,
        fullscreen: false,
        title: config.title,
      },
      props: {
        ...defaultProps,
      },
    },
  ];
};
